<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg fill="currentColor" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.563,17.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
		<path
			d="M14.563,17.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
		<path
			d="M14.563,49.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
		<path
			d="M14.563,49.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
		<path
			d="M14.563,33.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
		<path
			d="M14.563,33.167l7.468,-7.468l2.61,2.61l-10.107,10.107l-6.359,-6.358l2.64,-2.64l3.748,3.749Zm41.456,0.806l-27.993,0l0,-3.969l27.993,0l0,3.969Z"
		></path>
	</svg>
</div>
